var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-popup',{attrs:{"classContent":"popup-example","title":_vm.popTitle,"active":_vm.popupActive,"buttonCloseHidden":""},on:{"update:active":function($event){_vm.popupActive=$event}}},[_vm._t("body")],2)}
var staticRenderFns = []

export { render, staticRenderFns }